import { render, staticRenderFns } from "./MainSliderGroup.vue?vue&type=template&id=8797fc18&"
import script from "./MainSliderGroup.vue?vue&type=script&lang=js&"
export * from "./MainSliderGroup.vue?vue&type=script&lang=js&"
import style0 from "./MainSliderGroup.vue?vue&type=style&index=0&id=8797fc18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports